import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { MediaService } from "src/app/core/services/media.service";
import { SharedService } from "src/app/core/services/shared.service";
import { V3ServicesService } from "src/app/core/services/v3-services.service";

@Component({
  selector: "app-custom-vission",
  templateUrl: "./custom-vission.component.html",
  styleUrls: ["./custom-vission.component.scss"],
})
export class CustomVissionComponent {
  @Input() sortData;
  isSorting: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    public toastr: ToastrService,
    private api: SharedService,
    private mediaApi: V3ServicesService
  ) {}

  closeModal(status) {
    this.activeModal.close(status);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.sortData?.list,
      event.previousIndex,
      event.currentIndex
    );
  }

  confirmSort() {
    const pass_data = this.sortData.list.map((ae, i) => ({
      heading: ae.heading,
      id: ae.id,
      description: ae.description,
      // priority: i,
      is_updated: true,
    }));
    this.isSorting = true;
    this.mediaApi.setVissionService( pass_data ).subscribe(
      (res: any) => {
        this.isSorting = false;
        this.toastr.success("Positions Changed!");
        this.closeModal(true);
      },
      () => {
        this.isSorting = false;
      }
    );
  }
}
